module.exports = __webpack_public_path__ + "img/gd3.503d2f7a.jpg";